/**
 * 主題功能配置
 * 每個主題都明確配置自己的功能
 * 不依賴預設值
 */

const themeFeatures = {
  theme_gold: {
    showChatBox: true,
    showSupportCenter: true,
    showBlog: true,
    showAffiliates: true,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: true,
    showFollowUs: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: true,
    showWithdrawalDesc: true,
    showVipContent: true,
    showMyWallet: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: true,
    showPersonalAd: true,
    showGameRTP: false
  },
  theme_blue: {
    showChatBox: true,
    showSupportCenter: false,
    showBlog: false,
    showAffiliates: true,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: false,
    showFollowUs: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showMyWallet: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: false,
    showPersonalAd: false,
    showGameRTP: false
  },
  theme_purple: {
    showChatBox: true,
    showSupportCenter: false,
    showBlog: false,
    showAffiliates: false,
    showEvent: false,
    showBankCreate: false,
    showUserLetter: false,
    showNews: false,
    showSupMenu: false,
    showFooterText: false,
    showFollowUs: false,
    showFooterBank: false,
    showFooterProviders: false,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: false,
    showFooterHelpCenter: false,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: false,
    showMyWallet: false,
    showKYC: false,
    showKYCTips: false,
    showPayTypeList: true,
    showPersonalAd: true,
    showGameRTP: false
  },
  theme_royalgold: {
    showChatBox: false,
    showSupportCenter: false,
    showBlog: false,
    showAffiliates: false,
    showEvent: false,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: true,
    showFollowUs: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showMyWallet: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: true,
    showPersonalAd: false,
    showGameRTP: false
  }
}

/**
 * 獲取當前主題的完整配置
 */
export function getCurrentThemeConfig() {
  const currentTheme = process.env.VUE_APP_THEME || 'theme_gold'
  const config = themeFeatures[currentTheme]

  if (!config) {
    console.error(`未找到主題配置: ${currentTheme}`)
    return {}
  }

  return config
}

/**
 * 檢查當前主題是否啟用某功能
 */
export function hasFeature(featureName) {
  const config = getCurrentThemeConfig()
  return config[featureName] ?? false
}

/**
 * 獲取當前主題名稱
 */
export function getCurrentTheme() {
  return process.env.VUE_APP_THEME || 'theme_gold'
}

export default {
  getCurrentThemeConfig,
  hasFeature,
  getCurrentTheme
}
